import React, { Component } from 'react'
import {
  RenderConfiguredVehicleCompact,
  HeadingBlock,
  RenderConfiguredVehicle
} from 'containers'
import { Tabs } from 'components'
import { H2, H6, Space } from 'AtomicComponents'

class BuildBodyStep extends Component {
  _renderToggles = () => (
    <div>
      {this.props.stepData.radioGroup.map((radio, index) => {
        const props = {
          onChange: this.props.handleChangeOption,
          options: this.props.options[radio.groupName],
          active: this.props.options[radio.groupName].indexOf(this.props.options[radio.itemName]),
          only: this.props.options[radio.groupName].length <= 1
        }
        if (index === 0) {
          return (
            <div key={index} style={{ marginBottom: '1em' }} data-test={radio.groupName}>
              <Tabs animatedLine primary {...props} />
            </div>
          )
        }
        return (
          <div
            key={index}
            style={{ display: 'inline-block', marginBottom: '1em' }}
            data-test={radio.groupName}>
            {index === this.props.stepData.radioGroup.length - 1 && (
              <div style={stepStyles.divider} />
            )}
            <div key={index} style={{ display: 'inline-block' }}>
              <Tabs divider {...props} />
            </div>
          </div>
        )
      })}
    </div>
  )

  _renderCompact = () => {
    const currentPrice = ((this.props.price || {}).data || [])[0] || {}
    return (
      <div>
        <RenderConfiguredVehicleCompact
          display360={this.props.display360}
          step={this.props.stepData}
          isSelectColorInterior={this.props.selectColorInterior}
          options={this.props.options}
          onChange={this.props.handleChangeOption}
          currentPriceArray={currentPrice}
          showDescription />
      </div>
    )
  }

  _render = () => {
    const currentPrice = ((this.props.price || {}).data || [])[0] || {}
    return (
      <div>
        <div style={stepStyles.stepHeader}>
          <H6 withDetails>
            {this.props.mainHeading}
          </H6>
          <H2
            withDetails
            align={'center'}
          >
            {this.props.stepData.heading}
          </H2>
          <Space />
          {this._renderToggles()}
        </div>
        <div style={{ padding: '0em 15vw' }}>
          <RenderConfiguredVehicle
            display360={this.props.display360}
            step={this.props.stepData}
            isSelectColorInterior={Boolean(this.props.selectColorInterior)}
            options={this.props.options}
            onChange={this.props.handleChangeOption}
            selectIndex={
              this.props.stepData.colorSelector && (this.props.selectColorInterior ? 1 : 0)
            }
            showDescription
            background={!this.props.stepData.fullWidth} />
        </div>
      </div>
    )
  }

  render() {
    return this.props.compact ? this._renderCompact() : this._render()
  }
}
export default BuildBodyStep

const stepStyles = {
  divider: {
    height: '2em',
    width: '1px',
    margin: '0px 1.8em 0 1.7em',
    background: '#cbcbcb',
    transform: 'rotate(30deg)',
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  stepHeader: {
    paddingTop: '30px',
    minHeight: '20vh'
  }
}



// WEBPACK FOOTER //
// ./src/containers/build/build-body-step.jsx